"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionProductToJSON = exports.SubscriptionProductFromJSONTyped = exports.SubscriptionProductFromJSON = exports.SubscriptionProduct = void 0;
/**
 *
 * @export
 */
exports.SubscriptionProduct = {
    Unset: 'UNSET',
    Free: 'FREE',
    Premium: 'PREMIUM'
};
function SubscriptionProductFromJSON(json) {
    return SubscriptionProductFromJSONTyped(json, false);
}
exports.SubscriptionProductFromJSON = SubscriptionProductFromJSON;
function SubscriptionProductFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SubscriptionProductFromJSONTyped = SubscriptionProductFromJSONTyped;
function SubscriptionProductToJSON(value) {
    return value;
}
exports.SubscriptionProductToJSON = SubscriptionProductToJSON;
